export type Point = {
  x: number;
  y: number;
};

export enum PointShape {
  ROUND = 'round',
  SQUARE = 'square',
}
export type BBox = [Point, Point, Point, Point];

export type DrawingCanvasShapeKey = string;

export enum DrawingCanvasShapeType {
  LINE = 'line',
  POINT = 'point',
  POLYGON = 'polygon',
  BBOX = 'bbox',
  BBOX_CORNER = 'bbox-corner',
  VERTEX = 'vertex',
}

export enum DrawingCanvasMode {
  EDIT = 'edit',
  DRAW = 'draw',
}

export type DrawingCanvasShapeStyleBase = {
  fillColor?: RGBColor;
  strokeColor?: RGBColor;
  lineWidth?: number;
  isSelected?: boolean;
  isHighlighted?: boolean;
};
export type DrawingCanvasPointStyle = DrawingCanvasShapeStyleBase & { pointShape?: PointShape };
export type DrawingCanvasLineStyle = DrawingCanvasShapeStyleBase & { dashed?: boolean };

type DrawingCanvasShapeBase = {
  key: DrawingCanvasShapeKey;
  points: Point[];
  order: number;
  style?: DrawingCanvasShapeStyleBase;
};

type DrawingCanvasLine = {
  type: DrawingCanvasShapeType.LINE;
  style?: DrawingCanvasLineStyle;
} & Omit<DrawingCanvasShapeBase, 'style'>;

type DrawingCanvasPolygon = {
  type: DrawingCanvasShapeType.POLYGON;
} & DrawingCanvasShapeBase;

type DrawingCanvasPoint = {
  type: DrawingCanvasShapeType.POINT;
  style?: DrawingCanvasPointStyle;
} & Omit<DrawingCanvasShapeBase, 'style'>;

export type DrawingCanvasShape = DrawingCanvasLine | DrawingCanvasPolygon | DrawingCanvasPoint;

type SelectedFeatureBase = DrawingCanvasShapeBase & { index: number };

type DrawingCanvasBBox = {
  type: DrawingCanvasShapeType.BBOX;
} & DrawingCanvasShapeBase;

type DrawingCanvasBBoxCorner = {
  type: DrawingCanvasShapeType.BBOX_CORNER;
  style?: DrawingCanvasPointStyle;
} & Omit<SelectedFeatureBase, 'style'>;

type DrawingCanvasVertex = {
  type: DrawingCanvasShapeType.VERTEX;
  style?: DrawingCanvasPointStyle;
} & Omit<SelectedFeatureBase, 'style'>;

export type DrawingCanvasSelectedFeature = DrawingCanvasBBox | DrawingCanvasBBoxCorner | DrawingCanvasVertex;

export type DrawingCanvasShapes = Record<DrawingCanvasShapeKey, DrawingCanvasShape>;

export type RGBColor = string;

export type DrawingCanvasShapeKeyToColorMap = Record<DrawingCanvasShapeKey, RGBColor>;
export type DrawingCanvasColorToShapeKeyMap = Record<RGBColor, DrawingCanvasShapeKey>;
